import { ProfileInfoCard } from "@/pages/profile/components/profile-info-card";
import { CertifyCard } from "@/pages/profile/view/certify-card";
import ModalFormStoreProvider from "@/pages/profile/store/modal-form-store";
import CaptchaManager, {
  CaptchaBusiness,
} from "project-config/services/captcha";
import { useEffect, useRef } from "react";
import { AccountSecurity } from "@/pages/profile/view/account-security";
import { ProfileStyle } from "./atom.js";
import { ThreePartyBinding } from "@/pages/profile/view/three-party-binding";
import { FoxThreePartyLink } from "@/pages/profile/view/fox-three-party-link";
import { useGlobalStore } from "@/store/GlobalStore";
import { Space } from "antd";
import { CertifyStoreProvider, useCertifyStore } from "./store/certify-store";
import { isEn } from "project-config/utils/env";
import { safeSetTitle } from "project-config/utils/title";

function View() {
  const {
    isDomestic,
    userInfo,
    isCertified,
    isPictureUser,
    studentData,
    isSubAccount,
  } = useGlobalStore();
  const { loading, certifyStatus } = useCertifyStore();

  // 错误测试
  if (
    new URLSearchParams(window.location.search).get("showErrorPage") === "true"
  ) {
    throw new Error("TEST_PROFILE_ERROR");
  }

  return (
    <Space size={24} className="profile-page-wrapper">
      <ProfileInfoCard />
      <Space size={24} direction="vertical" className="vertical">
        <AccountSecurity />
        {isDomestic ? (
          <ThreePartyBinding />
        ) : !isSubAccount ? (
          <FoxThreePartyLink />
        ) : null}
        <CertifyCard
          userInfo={userInfo}
          isCertified={isCertified}
          loading={loading}
          studentData={studentData}
          certifyStatus={certifyStatus}
          isDomestic={isDomestic}
          isPictureUser={isPictureUser}
          isSubAccount={isSubAccount}
        />
      </Space>
      <ProfileStyle />
    </Space>
  );
}
export default function Profile() {
  const loadRef = useRef(false);
  useEffect(() => {
    if (loadRef.current) return;
    isEn() &&
      safeSetTitle(
        "User Profile on Cloud Rendering Web Console - Fox Renderfarm"
      );
    const captchaBusiness = !isEn()
      ? CaptchaBusiness.Renderbus
      : CaptchaBusiness.Foxrenderfarm;
    CaptchaManager.init(captchaBusiness);
    loadRef.current = true;
    return () => {
      CaptchaManager.destory();
    };
  }, []);

  return (
    <ModalFormStoreProvider>
      <CertifyStoreProvider>
        <View />
      </CertifyStoreProvider>
    </ModalFormStoreProvider>
  );
}
